export enum LIST_TYPE_MY_ASSET {
  HOLD = 'HOLD',
  FINISH = 'FINISH',
  HISTORY = 'HISTORY',
}

export const ASSET_TAB = {
  HOLD: 'HOLD',
  FINISH: 'FINISH',
}

type ASSET_TAB_TYPE = (typeof ASSET_TAB)[keyof typeof ASSET_TAB]

export enum LIST_TYPE_ARTFAIR {
  ART_MUSEUM = 'ART_MUSEUM',
  EVENT = 'EVENT',
}

export const NOTIFICATION_TAP = {
  NOTICE: 'NOTICE',
  NOTIFICATION: 'NOTIFICATION',
} as const

type NOTIFICATION_TAP_TYPE = (typeof NOTIFICATION_TAP)[keyof typeof NOTIFICATION_TAP]

export const LIST_MARKET = {
  SALE: 'SALE',
  SALE_OFF: 'SALE_OFF',
} as const

type LIST_MARKET_TYPE = (typeof LIST_MARKET)[keyof typeof LIST_MARKET]

export type { LIST_MARKET_TYPE, ASSET_TAB_TYPE, NOTIFICATION_TAP_TYPE }
